import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import urls from './urls';
import { getMessaging, getToken } from "firebase/messaging";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

const publicVapidKey = 'BHYe2bRSm37x7MHPxeABwPAL6ocDQVx2luO5evQbyfVKi1D0HE5AlAORuEh-cPbdZx8jyAkWvbMlldazwPFU1W4';
const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

// register the service worker, register our push api, send the notification
const send = async () => {
  // register service worker
  const register = await navigator.serviceWorker.getRegistration();
  // const register = await navigator.serviceWorker.register('/service-worker.js');

  //register push
  const subscription = await register.pushManager.subscribe({
      userVisibleOnly: true,
      // public vapid key
      applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
  });

  if (typeof localStorage.getItem("userData") != 'undefined') {
    fetch(urls.subscribe, {
      method: "POST",
      body: JSON.stringify({ 
        subscription,
        userId: JSON.parse(localStorage.getItem("userData")).id
      }),
      headers: {
          "content-type": "application/json"
      }
    }).catch(err => {
      console.warn("Failed to fetch /subscribe:", err);
    });
  }
};

if ('serviceWorker' in navigator) {
  // send().catch(err => console.error(err));
  navigator.serviceWorker.register("./firebase-messaging-sw.js")
      .then(registration => {
        const messaging = getMessaging();
        if (typeof localStorage.getItem("userData") != 'undefined')
            getToken(messaging, { vapidKey: 'BDTjqKt8-EHUV56U_XSgsBxgPZsUBFp6hbSUcxaT8RMHQ28dmlo9HahhHYV2KCOx7gH5pCdrMC1WQzceyev4TQQ', serviceWorkerRegistration: registration }).then((currentToken) => {
                if (currentToken) {
                    fetch(urls.subscribe, {
                        method: "POST",
                        body: JSON.stringify({ 
                            subscription: currentToken,
                            userId: JSON.parse(localStorage.getItem("userData")).id
                        }),
                        headers: {
                            "content-type": "application/json"
                        }
                    }).catch(err => {
                        console.warn("Failed to fetch /subscribe:", err);
                    });
                } else {
                    // Show permission request UI
                    console.log('No registration token available. Request permission to generate one.');
                    // ...
                }
            }).catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
                // ...
            });
      });
}
